import {
	NOTIFICATION,
	type NotiFicationDatum,
	type SnackKey
} from 'config/notifications'
import { useCallback } from 'react'
import { useAppDispatch } from 'shared/hooks'

import { actions } from './slice'

export function useSnack() {
	const dispatch = useAppDispatch()

	return useCallback(
		(input: NotiFicationDatum | SnackKey) => {
			const isId = typeof input === 'string'

			const nextSnack = isId ? NOTIFICATION[input] : input

			const action = actions.showSnack(nextSnack)

			dispatch(action)
		},
		[dispatch]
	)
}
